<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Editar verificación">
          <verificacion-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import VerificacionForm from "@/components/Forms/VerificacionForm.vue";
import CCard from "@/components/CCard.vue";
export default {
  components: {
    VerificacionForm,
    CCard,
  },
};
</script>
